import { render } from "./createReport.vue?vue&type=template&id=0aa1c5ee"
import script from "./createReport.vue?vue&type=script&lang=js"
export * from "./createReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__